<div class="modal fade  add-session-modal" hznTestId="session-add-modal" id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <button class="close" data-dismiss="modal"></button>
                    </div>

                    <app-session-basic-info-edit #sessionEditComponent [context]="context" [isNew]="true"  [form]="basicInfoForm"></app-session-basic-info-edit>

                    <div class="row mt-1">
                        <div class="col-md-12">
                            <button class="btn btn-success btn-action pull-right" [disabled]="!isFormValid()" type="button" bcClick hznTestId="session-add-save" (clicked)="onSave()">{{'General.Save' | translate}}</button>                       
                            <button class="btn btn-danger btn-action pull-right mr-1"   type="button" bcClick (clicked)="cancel()">{{'General.Cancel' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>